import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Empty, Modal, Tag, Tooltip } from "antd";
import { useState } from "react";
import type { UploadChangeParam } from "antd/es/upload";
import { faCopy, faEye, faMapLocationDot } from "@fortawesome/free-solid-svg-icons";

//STYLE
import { Container } from "./styled";

//APP
import { localConfig } from "../../../../../../Configs/localConfig";
import { OsItensTypes } from "../../../../../../services/Laboratorio";
import { handleUploadResult } from "../../meta";
import { useEnviarResultado } from "../../../../../../services/Laboratorio/MUTATIONS";
import { useDeletePedidoLaboratorio } from "../../../../../../services/Laboratorio/DELETE";
import { motivoSemPermissao, usePermissoesOs } from "../../meta/usePermissoesOs";
import { destroyAlert, errorAlert, successAlert } from "../../../../../../utils/alert";
import { exibirClienteNaLinha, mensagemClienteDivergente, motivoSemClienteGlobal, podeAbrirOs } from "./meta/acessoCliente";
import { getPedLaboratorioStatus, putPedlaboratorioStatus } from "../../../../../../services/Laboratorio";
import { alternarOrdenacao, type ColunaOrdenavel, type EstadoOrdenacao } from "./meta/ordenarOs";
import { dados_status, statusBackground, statusBorder, statusColor, statusIcones, statusNomes, STATUS_EM_ANALISE } from "./meta";

//COMPONENTS
import Carregando from "../../../../../../Components/CustomUi/loading";
import ButtonCustom from "../../../../../../Components/ButtonCustom";
import CsvVisualizationModal from "./components/visualizarArquivoCSV";
import { Render } from "../../../../../../Components/CustomUi/render";
import { RowItem } from "../../../../../../Components/CustomUi/table/rowItem";
import { RowTable } from "../../../../../../Components/CustomUi/table/rowTable";
import { BodyTable } from "../../../../../../Components/CustomUi/table/bodyTable";
import { HeaderTable } from "../../../../../../Components/CustomUi/table/headerTable";
import { IconeAlerta } from "./components/iconeAlerta";
import { DeleteButton } from "../../../../../../Components/CustomUi/deleteButton";
import { StatusTimeLine } from "./components/statusTimeLine";
import { FormularioOsColeta } from "./components/formulario";
import { ImprimirOrdem } from "./components/imprimirOrdem";
import { VisualizarMapaTabela } from "./components/visualizarMapaTabela";
import { AcaoArquivo } from "./components/acaoArquivo";
import { ChecarProcessamento } from "./components/checarProcessamento";

//PROPS
interface Props {
    lista_os: OsItensTypes[];
    /** `refetch` do react-query: devolve promise, usada para saber quando a
     *  recarga terminou (ver ChecarProcessamento). */
    refetch_data_osColeta: () => Promise<unknown> | void;
    /** Primeira carga: ainda não há nada para mostrar. */
    loading: boolean;
    /** Qualquer busca, inclusive troca de página com dados já em tela. */
    buscando?: boolean;
    /** Total de registros no servidor — base da paginação. */
    total: number;
    /** Quantidade após o filtro local por talhão (0 = sem filtro ativo). */
    total_filtrado?: number;
    page: number;
    setPage: React.Dispatch<React.SetStateAction<number>>;
    setPagination: React.Dispatch<React.SetStateAction<number>>;
    /** Ordenação da tabela — o pai é dono do estado (ordena a lista antes de paginar). */
    ordenacao: EstadoOrdenacao | null;
    setOrdenacao: React.Dispatch<React.SetStateAction<EstadoOrdenacao | null>>;
    /**
     * Gaveta em modo "criar", controlada pelo pai — o botão "Novo" fica no header
     * dele. Os modos editar/copiar são internos daqui (nascem da linha da tabela).
     */
    abrirNovaOs: boolean;
    setAbrirNovaOs: React.Dispatch<React.SetStateAction<boolean>>;
    /** Filtro da listagem: pré-preenche a propriedade da OS nova. */
    filtro_propriedade?: { cod: number | null; nome: string };
}

/**
 * Marca a coluna "Ações" para o duplo clique da linha ignorá-la.
 * Os botões da coluna abrem popovers/gavetas/modais que são renderizados dentro
 * da linha, então o duplo clique neles subiria até o `onDoubleClick` do
 * `RowTable` e abriria a gaveta de edição por trás.
 */
const ATTR_ACOES = 'data-acoes-os';

export const Solo: React.FC<Props> = ({
    lista_os, refetch_data_osColeta, loading, buscando, total, total_filtrado, page, setPage, setPagination,
    ordenacao, setOrdenacao, abrirNovaOs, setAbrirNovaOs, filtro_propriedade
}) => {

    //CONST
    /** Permissões do usuário para a rotina de OS (antes era `null` fixo, o que
     *  deixava todos os testes `permissions?.x === 0` sempre falsos). */
    const permissions = usePermissoesOs();

    /** Sem cliente no filtro global a lista mistura clientes: a linha precisa dizer de quem é. */
    const mostrar_cliente = exibirClienteNaLinha(localConfig()?.codCliente);

    /**
     * Sem cliente no filtro global a OS não pode ser gravada (iria para o cliente
     * errado). Clonar e enviar resultado ficam desabilitados; abrir a gaveta
     * continua liberado, em modo somente leitura.
     */
    const motivo_sem_cliente = motivoSemClienteGlobal(localConfig()?.codCliente);

    //#region STATES
    //GAVETA (cadastro/edição/cópia de OS)
    /** Abertura vinda da LINHA (editar/copiar). A de "criar" vem do pai por prop,
     *  então a gaveta abre com qualquer uma das duas. */
    const [abrirGavetaLinha, setAbrirGavetaLinha] = useState<boolean>(false);
    const [update, setUpdate] = useState<number | null>(null);
    const [copiar, setCopiar] = useState<number | null>(null);
    const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false);
    const [id_item_atual, setId_item_atual] = useState<number>(null);
    const [nome_item_atual, setNome_item_atual] = useState<string>('');
    const [resultAnalise, setResultAnalise] = useState({
        base64: null,
        cod: null,
    })
    const [textCSV, setTextCSV] = useState([])
    const [abrirPreviewFile, setAbrirPreviewFile] = useState<boolean>(false)

    //VISUALIZAR MAPA
    const [abrirMapa, setAbrirMapa] = useState<boolean>(false)
    const [cod_mapa, setCod_mapa] = useState<number>(null)
    //STATUS (linha do tempo)
    const [numero_pedido, setNumero_pedido] = useState<number>(null)
    const [abrirStatus, setAbrirStatus] = useState<boolean>(false)
    const [dataStatusOs, setDataStatusOs] = useState<any[]>([])
    const [status_selecionada, setStatus_selecionada] = useState<string>('')
    const [status_selecionada_id, setStatus_selecionada_id] = useState<number>(null)
    const [loading_status, setLoading_status] = useState<boolean>(false)
    // Data de entrega ao laboratorio informada junto com a troca de status. Opcional.
    const [data_entrega_lab_status, setData_entrega_lab_status] = useState<string>('')

    /** Alterna a ordenação da coluna clicada (asc -> desc -> asc). */
    function alternarColuna(coluna: ColunaOrdenavel) {
        setOrdenacao((atual) => alternarOrdenacao(atual, coluna))
    }

    // `lista_os` já chega filtrada, ordenada e recortada pelo pai.

    //#region API
    const { mutate_excluir_os, carregando_excluir_os } = useDeletePedidoLaboratorio()
    const { mutate_enviar_resultado, carregando_enviar_resultado } = useEnviarResultado()

    /**
     * Envia ao backend o arquivo de resultado já pré-visualizado. Só fecha a
     * pré-visualização e limpa o estado em caso de sucesso — assim o usuário pode
     * tentar de novo sem refazer o upload se o backend recusar o arquivo.
     */
    function enviarResultado() {
        if (!resultAnalise?.base64 || !resultAnalise?.cod) {
            errorAlert('Nenhum arquivo carregado para enviar.')
            return
        }

        mutate_enviar_resultado(
            {
                cod: resultAnalise.cod,
                base64: resultAnalise.base64,
                refetch: refetch_data_osColeta,
            },
            {
                onSuccess: () => {
                    setAbrirPreviewFile(false)
                    setResultAnalise({ base64: null, cod: null })
                    setTextCSV([])
                },
            }
        )
    }

    /** Nome de exibição do status. Lê de `statusNomes` (dicionário completo) e
     *  não de `dados_status` (só as opções selecionáveis) — era essa confusão
     *  que deixava os status 6/7/8 com a tag em branco. */
    function verificarStatusNome(cod: number) {
        const nome = statusNomes[cod]
        return nome === 'ENVIADO PARA ANÁLISE' ? 'ENVIADO' : nome
    }

    /** Recebe o arquivo escolhido na linha e abre o preview de CSV, que é
     *  renderizado aqui (fora da linha) e compartilhado por todas as OS. */
    function enviarParaPreview(info: UploadChangeParam, cod: number) {
        handleUploadResult(info, cod, setResultAnalise, setTextCSV, setAbrirPreviewFile)
    }
    async function abrirModal(cod: number) {
        setLoading_status(true)
        setNumero_pedido(cod)
        setAbrirStatus(true)
        // loadingAlert({ msg: 'Carregando pedidos...', id: 'pedido' })
        const response = await getPedLaboratorioStatus(cod)
        const dados = response.data.itens
        setDataStatusOs([...dados].reverse())
        destroyAlert('pedido')
        setLoading_status(false)
    }

    const alterarStatus = async () => {
        setLoading_status(true)
        if (status_selecionada_id) {
            const listaStatus = (dados_status ?? []).find((data) => data.cod === status_selecionada_id)
            const response = await putPedlaboratorioStatus(
                numero_pedido,
                listaStatus.cod,
                data_entrega_lab_status ? dayjs(data_entrega_lab_status).format('YYYY-MM-DD') : null
            )

            if (response.status === 200) {
                successAlert(`Status da OS alterado para ${listaStatus.nome}`)
                setLoading_status(false)
                refetch_data_osColeta()
                setAbrirStatus(false)
            } else {
                errorAlert(`ERROR ${response.status}`)
                setLoading_status(false)
            }
        } else {
            errorAlert('Selecione o status para ser alterado')
            setLoading_status(false)
        }
    }

    function fecharModal() {
        setNumero_pedido(null)
        setStatus_selecionada('')
        setStatus_selecionada_id(null)
        setData_entrega_lab_status('')
        setAbrirStatus(false)
    }

    //#region GAVETA
    // A gaveta abre em modo criar quando o pedido vem do pai (`abrirNovaOs`) e em
    // editar/copiar quando vem da linha. Não há efeito sincronizando os modos:
    // `fecharGaveta` é a única saída e já zera update/copiar, então o pedido do
    // pai sempre encontra os dois em `null`.

    /**
     * Em acesso multi-cliente (sem cliente selecionado), abrir a OS de um cliente
     * específico faria o salvar gravar com o `codCliente` errado — a mesma trava
     * existe na versão em produção.
     */
    function bloqueadoPorCliente(cod_cliente: number | null, acao: 'editar' | 'clonar', nome_cliente?: string): boolean {
        if (podeAbrirOs(cod_cliente, localConfig()?.codCliente)) return false;

        Modal.error({ title: mensagemClienteDivergente(acao, nome_cliente) });
        return true;
    }

    // Abrir é sempre permitido: sem cliente global a gaveta entra em somente
    // leitura (o salvar fica desabilitado), em vez de barrar a visualização.
    function editarOs(cod: number, _cod_cliente?: number | null, _nome_cliente?: string) {
        setCopiar(null);
        setUpdate(cod);
        setAbrirGavetaLinha(true);
    }

    function copiarOs(cod: number, cod_cliente?: number | null, nome_cliente?: string) {
        if (bloqueadoPorCliente(cod_cliente ?? null, 'clonar', nome_cliente)) return;

        setUpdate(null);
        setCopiar(cod);
        setAbrirGavetaLinha(true);
    }

    function fecharGaveta() {
        // Desliga as duas origens: se só a local fosse zerada, a prop do pai
        // continuaria `true` e a gaveta reabriria no render seguinte.
        setAbrirGavetaLinha(false);
        setAbrirNovaOs(false);
        setUpdate(null);
        setCopiar(null);
    }

    function abrirVisualizarMapa(cod: number) {
        setCod_mapa(cod);
        setAbrirMapa(true);
    }

    // A tabela só some quando o servidor não tem nenhum registro. Durante o
    // carregamento de uma nova página ela continua montada, senão a paginação
    // desapareceria justamente no clique que a acionou.
    const sem_registros = !loading && total === 0;

    return (
        <Container>
            {sem_registros && (
                <Empty
                    style={{ marginTop: 100 }}
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={<>Nenhuma Ordem de serviço cadastrada</>}
                />
            )}

            <Render condition={!sem_registros}>
                <HeaderTable
                    itens={[
                        { valor: '', width: 41 },
                        {
                            valor: 'Data coleta',
                            width: 129.5,
                            onSort: () => alternarColuna('data_coleta'),
                            sorting: ordenacao?.coluna === 'data_coleta',
                            typeSort: ordenacao?.coluna === 'data_coleta' ? ordenacao.direcao : undefined,
                        },
                        {
                            valor: 'Data Liberada',
                            width: 130.5,
                            onSort: () => alternarColuna('data_liberada'),
                            sorting: ordenacao?.coluna === 'data_liberada',
                            typeSort: ordenacao?.coluna === 'data_liberada' ? ordenacao.direcao : undefined,
                        },
                        {
                            valor: 'Propriedade',
                            width: 'calc((100% - 843px) / 2)',
                            onSort: () => alternarColuna('propriedade_nome'),
                            sorting: ordenacao?.coluna === 'propriedade_nome',
                            typeSort: ordenacao?.coluna === 'propriedade_nome' ? ordenacao.direcao : undefined,
                        },
                        {
                            valor: 'Talhão',
                            width: 'calc((100% - 875px) / 2)',
                            onSort: () => alternarColuna('talhao_nome'),
                            sorting: ordenacao?.coluna === 'talhao_nome',
                            typeSort: ordenacao?.coluna === 'talhao_nome' ? ordenacao.direcao : undefined,
                        },
                        {
                            valor: 'Status',
                            width: 160,
                            onSort: () => alternarColuna('status'),
                            sorting: ordenacao?.coluna === 'status',
                            typeSort: ordenacao?.coluna === 'status' ? ordenacao.direcao : undefined,
                        },
                        { valor: 'Ações', width: 388 },
                    ]}
                    style={{ flexShrink: 0 }}
                />

                <BodyTable
                    paginate={total}
                    paginateFilter={total_filtrado}
                    onChangeItensPage={setPagination}
                    onChangePage={setPage}
                    current_page={page}
                    setCurrent_page={setPage}
                    style={{ flex: 1, minHeight: 0 }}
                >
                    {/* Primeira carga: nada em tela ainda, spinner ocupa a tabela. */}
                    <Render condition={loading}>
                        <Carregando
                            animation
                            legenda="Carregando ordens de serviço..."
                            justifyContent="center"
                            height={400}
                        />
                    </Render>

                    {/* Troca de página/busca: linhas antigas seguem visíveis por baixo. */}
                    <Render condition={!loading && buscando}>
                        <div className="Solo__overlayBuscando">
                            <div className="Solo__overlayBuscando__fundo">
                                <Carregando
                                    animation
                                    legenda="Carregando ordens de serviço..."
                                    justifyContent="center"
                                    size="default"
                                />
                            </div>
                        </div>
                    </Render>

                    {!loading && (lista_os ?? []).map(({ cod, cod_calcario, cod_safra_conta, cod_calcario_propriedade, laboratorio_nome,
                        observacao, resultado_inconsistente, data_coleta, data_liberada, talhao_nome, status,
                        propriedade_nome, arquivo_processado_url, arquivo_processado, cod_cliente, cliente_nome
                    }) => {
                        return (
                            <RowTable
                                key={cod}
                                // O duplo clique na linha abre a edição, mas os botões da
                                // coluna "Ações" (popovers, gavetas de impressão, modais)
                                // são filhos dela — sem esse guard, dois cliques dentro de
                                // qualquer um deles abriam a gaveta de edição por trás.
                                onDoubleClick={(event) => {
                                    const alvo = event.target as HTMLElement | null
                                    if (alvo?.closest?.(`[${ATTR_ACOES}]`)) return
                                    editarOs(cod, cod_cliente, cliente_nome)
                                }}
                            >
                                <RowItem width={40}>
                                    <IconeAlerta
                                        cod_calcario={cod_calcario}
                                        cod_calcario_propriedade={cod_calcario_propriedade}
                                        cod_safra_conta={cod_safra_conta}
                                        laboratorio_nome={laboratorio_nome}
                                        cliente_nome={cliente_nome}
                                        observacao={observacao}
                                        resultado_inconsistente={resultado_inconsistente}
                                        status={status}
                                    />
                                </RowItem>
                                <RowItem fontSize={13} width={130}>
                                    {data_coleta === null ? '' : dayjs(data_coleta).format('DD/MM/YYYY')}
                                </RowItem>
                                <RowItem fontSize={13} width={130}>
                                    {data_liberada === null ? '' : dayjs(data_liberada).format('DD/MM/YYYY')}
                                </RowItem>
                                <RowItem fontSize={12} style={{ lineHeight: 1 }} width={'calc((100% - 835px) / 2)'}>
                                    <div className='Solo__propriedade'>
                                        {/* Sem cliente no filtro global a lista mistura vários
                                            clientes, e só a linha diz de quem é a propriedade.
                                            Com um cliente selecionado a tag seria a mesma em
                                            todas as linhas — ver `exibirClienteNaLinha`. */}
                                        <Render condition={mostrar_cliente && !!cliente_nome}>
                                            <Tooltip title={`Nome do cliente`} placement='topLeft'>
                                                <Tag className='Solo__propriedade__cliente' color="processing" bordered={false} style={{ textTransform: 'capitalize' }}>
                                                    {String(cliente_nome).toLowerCase()}
                                                </Tag>
                                            </Tooltip>
                                        </Render>
                                        <span style={{ textTransform: 'capitalize', fontSize: (mostrar_cliente && !!cliente_nome) ? 10.5 : 12 }}>{String(propriedade_nome).toLowerCase()}</span>

                                    </div>
                                </RowItem>
                                <RowItem fontSize={12} style={{ lineHeight: 1 }} width={'calc((100% - 870px) / 2)'}>
                                    {talhao_nome}
                                </RowItem>
                                <RowItem width={160} gap={4}>
                                    <Tag
                                        className='tag_os'
                                        color={statusBackground[status]}
                                        style={{
                                            color: statusColor[status],
                                            border: `1px solid ${statusBorder[status]}`,
                                            cursor: 'pointer',
                                            whiteSpace: 'pre-wrap',
                                            margin: 0
                                        }}
                                        onClick={() => abrirModal(cod)}
                                    >
                                        <FontAwesomeIcon icon={statusIcones[status]} />
                                        {' '}
                                        {verificarStatusNome(status)}
                                    </Tag>

                                    {/* O backend processa o arquivo e muda o status sozinho, mas não
                                        avisa o front. Enquanto não há notificação, o usuário confere
                                        no clique — o atributo tira o botão do duplo clique da linha. */}
                                    <Render condition={status === STATUS_EM_ANALISE}>
                                        <span {...{ [ATTR_ACOES]: true }} style={{ display: 'inline-flex' }}>
                                            <ChecarProcessamento cod={cod} refetch={refetch_data_osColeta} />
                                        </span>
                                    </Render>
                                </RowItem>
                                <RowItem width={'388px'} gap={10}>
                                    {/* O atributo marca tudo que é ação: o duplo clique da
                                        linha ignora eventos originados aqui dentro. */}
                                    <div {...{ [ATTR_ACOES]: true }} style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                        <Tooltip title={motivoSemPermissao(permissions?.exclusao !== 0, 'excluir OS') ?? "Excluir OS"} placement="bottom"><samp>
                                            <DeleteButton
                                                open={confirmar_exclusao && id_item_atual === cod}
                                                trigger={setConfirmar_exclusao}
                                                onTrigger={() => {
                                                    setId_item_atual(cod)
                                                    setNome_item_atual(propriedade_nome)
                                                }}
                                                loading={carregando_excluir_os}
                                                title="Tem certeza que deseja excluir essa OS?"
                                                message={
                                                    <div
                                                        style={{
                                                            width: '323px',
                                                            display: 'flex',
                                                            padding: '8px',
                                                            backgroundColor: '#FFF0D9',
                                                        }}
                                                    >
                                                        <h3 style={{ padding: '0px', margin: '0px', color: '#DF8600', lineHeight: '1.3', fontSize: '13px' }}>
                                                            {' '}
                                                            Atenção: Ao deletar essa OS comprometerá a sincronização no app caso
                                                            esteja ocorrendo a execução no campo.
                                                        </h3>
                                                    </div>
                                                }
                                                deleteds={[propriedade_nome]}
                                                onDelete={() => { mutate_excluir_os({ cod_os: cod, refetch_data_osColeta }) }}
                                                disabled={carregando_excluir_os || permissions?.exclusao === 0}
                                                typeButtonTrigger='tertiary'
                                            /></samp>
                                        </Tooltip>

                                        <Tooltip title={motivoSemPermissao(!(permissions?.acesso === 0 && permissions?.alteracao === 0), 'visualizar a OS') ?? "Visualizar pontos do talhão"}><samp>
                                            <ButtonCustom
                                                icon={<FontAwesomeIcon icon={faMapLocationDot} />}
                                                type='secondary'
                                                onClick={() => { abrirVisualizarMapa(cod); }}
                                                disabled={permissions?.acesso === 0 && permissions?.alteracao === 0}
                                            />
                                        </samp></Tooltip>


                                        <Tooltip title={motivoSemPermissao(permissions?.inclusao !== 0, 'clonar OS') ?? motivo_sem_cliente ?? "Clonar O.S"}><samp>
                                            <ButtonCustom
                                                icon={<FontAwesomeIcon icon={faCopy} />}
                                                type='secondary'
                                                onClick={() => { copiarOs(cod, cod_cliente, cliente_nome); }}
                                                disabled={permissions?.inclusao === 0 || !!motivo_sem_cliente}
                                            />
                                        </samp></Tooltip>

                                        {/* BOTÃOS DE UPLOAD/DOWNLOD */}
                                        <AcaoArquivo
                                            motivo_bloqueio={motivo_sem_cliente}
                                            cod={cod}
                                            status={status}
                                            arquivo_processado={arquivo_processado}
                                            arquivo_processado_url={arquivo_processado_url}
                                            cod_cliente={cod_cliente}
                                            propriedade_nome={propriedade_nome}
                                            talhao_nome={talhao_nome}
                                            cod_calcario={cod_calcario}
                                            cod_calcario_propriedade={cod_calcario_propriedade}
                                            refetch={refetch_data_osColeta}
                                            onUpload={enviarParaPreview}
                                        />

                                        <ImprimirOrdem cod={cod} status={status} />

                                        <Tooltip title={motivoSemPermissao(!(permissions?.acesso === 0 && permissions?.alteracao === 0), 'abrir a OS')}><span>
                                            <ButtonCustom
                                                icon={<FontAwesomeIcon icon={faEye} />}
                                                onClick={() => {
                                                    editarOs(cod, cod_cliente, cliente_nome)
                                                }}
                                                disabled={permissions?.acesso === 0 && permissions?.alteracao === 0}
                                            >
                                                {!!motivo_sem_cliente ? 'Visualizar' : 'Ver / Editar'}
                                            </ButtonCustom>
                                        </span></Tooltip>
                                    </div>
                                </RowItem>
                            </RowTable>
                        )
                    })}

                    {/* Servidor tem registros, mas o filtro por talhão zerou esta página. */}
                    <Render condition={!loading && (lista_os ?? []).length === 0}>
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={<>Nenhuma OS encontrada nesta página</>}
                        />
                    </Render>
                </BodyTable>

                <VisualizarMapaTabela
                    open={abrirMapa}
                    update={cod_mapa}
                    setOpen={setAbrirMapa}
                />

                <StatusTimeLine
                    numero_pedido={numero_pedido}
                    abrirStatus={abrirStatus}
                    setAbrirStatus={setAbrirStatus}
                    status_selecionada={status_selecionada}
                    setStatus_selecionada={setStatus_selecionada}
                    setStatus_selecionada_id={setStatus_selecionada_id}
                    status_selecionada_id={status_selecionada_id}
                    data_entrega_lab={data_entrega_lab_status}
                    setData_entrega_lab={setData_entrega_lab_status}
                    dataStatusOs={dataStatusOs}
                    alterarStatus={alterarStatus}
                    loading_status={loading_status}
                    fecharModal={fecharModal}
                />

                <CsvVisualizationModal
                    isOpen={abrirPreviewFile}
                    onClose={() => setAbrirPreviewFile(false)}
                    dataCSV={textCSV}
                    onEnviar={enviarResultado}
                    enviando={carregando_enviar_resultado}
                />
            </Render>

            {/* Gaveta de cadastro/edição/cópia — sempre montada para permitir abrir
                mesmo com a lista vazia (via botão "Novo" do módulo pai). */}
            <FormularioOsColeta
                abrirGaveta={abrirGavetaLinha || abrirNovaOs}
                fecharGaveta={fecharGaveta}
                refetchLista={refetch_data_osColeta}
                update={update}
                copiar={copiar}
                filtro_propriedade={filtro_propriedade}
            />
        </Container>
    )
};